module.exports = __webpack_public_path__ + "a187f947ad79b7cb451a8b283c7287c3.png";